export const BASE_URL = process.env.PUBLIC_URL || "";
export const REACT_APP_PORTFOLIO_AI_API_URL = process.env.REACT_APP_PORTFOLIO_AI_API_URL || "";
